export default __webpack_public_path__ + "static/media/details.7765a5bf.svg";